import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Checkbox } from "antd"
import {
  IPreferencesMenuItem,
  IStateRequestUpdate,
  PreferencesMenuTypeEnum
} from "Data/interfaces/Preferences/IPreferences"
import { Column, Body, Header, } from "./styles"

interface ITableItem {
  activeType: PreferencesMenuTypeEnum
  itemParentId: string
  item: IPreferencesMenuItem
  index: number
  onStateUpdate: (values: IStateRequestUpdate) => void
}

const TableItem: FC<ITableItem> = ({
  activeType,
  itemParentId,
  item,
  index,
  onStateUpdate
}) => {
  const { t } = useTranslation('notification');
  const handleUpdate = (
    valueId: string,
    value: boolean | string,
    isLeft: boolean
  ) => {
    onStateUpdate({
      Type: activeType,
      itemParentId: itemParentId,
      itemChildrenId: item.Id,
      valueId: valueId,
      value: value,
      isLeft: isLeft
    })
  }

  return (
    <Column>
      <Header>
        <span className="columnTitle">{item.Title}</span>
        <span className="columnSigla">
          {index === 0 ? t('preferences.tableHeader.web') : ''}
        </span>
        <span className="columnEtapa">
          {index === 0 ? t('preferences.tableHeader.mobile') : ''}
        </span>
      </Header>
      <Body>
        {item.Items?.map(itemChildren => (
          <span key={itemChildren.Id} className="row">
            <span className="columnTitle">
              {itemChildren.Title}
            </span>
            <span className="columnSigla">
              <Checkbox
                checked={itemChildren.ValueLeft}
                onClick={() => handleUpdate(
                  itemChildren.Id,
                  !itemChildren.ValueLeft,
                  true
                )}
              />
            </span>
            <span className="columnEtapa">
              <Checkbox
                checked={itemChildren.ValueRight}
                onClick={() => handleUpdate(
                  itemChildren.Id,
                  !itemChildren.ValueRight,
                  false
                )}
              />
            </span>
          </span>
        ))}
      </Body>
    </Column>
  )
}

export default TableItem
